import React from "react";
import { Card, Col, Row, Statistic } from "antd";

const InvoiceStatistics = ({ loading, invoice }) => (
    <Row gutter={16}>
        <Col span={6}>
            <Card>
                <Statistic title="Total Fee" value={invoice?.fee?.total_fee_unpaid || 0} loading={loading} prefix="R" />
            </Card>
        </Col>
        <Col span={6}>
            <Card>
                <Statistic title="Base Fee" value={!invoice?.base_fee_paid ? invoice?.fee?.base_fee : 0} loading={loading} prefix="R" />
            </Card>
        </Col>
        <Col span={6}>
        <Card>
            <Statistic title="Group Fee" value={invoice?.fee?.group_fee} loading={loading} prefix="R" />
        </Card>
        </Col>
        <Col span={6}>
            <Card>
                <Statistic title="Additional Fee" value={invoice?.fee?.additional_fee || 0} loading={loading} prefix="R" />
            </Card>
        </Col>
    </Row>
);

export default InvoiceStatistics;  
